import { useEffect, useState } from 'react';
import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { storageService } from 'infrastructure/services/StorageService';
import { TUpdate } from 'domain/types';
import {
  CreateJobPostConfigContext,
  TCreateJobPostContextState,
} from 'domain/createJobPostConfig/CreateJobPostContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { createJobPostConfigSelectors } from 'domain/createJobPostConfig/selectors';
import { useNavigate } from 'react-router';

export const useDeleteJobPostById = (): any => {
  const navigate = useNavigate();
  const update: TUpdate<TCreateJobPostContextState> | undefined = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.update
  );
  const [jobPostId, setJobPostId] = useState<number | null>(null);

  useEffect(() => {
    storageService.getItem('createJobPostId').then((jobPost) => {
      if (!jobPost) return;
      const id = Number(jobPost);
      setJobPostId(id);
    });
  }, []);

  const { data, isLoading, send, status, error } = useRequest({
    url: `/api/v1/jobPosts/${jobPostId}`,
    method: ApiMethodsEnum.Delete,
    sendOnStart: false,
  });

  useEffect(() => {
    if (isLoading || error || status !== 200) return;
    if (update)
      update({ createJobPostData: null, screeningQuestions: [], isOpenBackToHomeModal: false });
    storageService.removeItem('createJobPostId').then();
    navigate('/profile/profileSettings');
    setJobPostId(null);
  }, [data, isLoading, error, status]);

  return {
    isLoading,
    send,
  };
};
